import { render, staticRenderFns } from "./ExpertsCard.vue?vue&type=template&id=7b00af06&scoped=true"
import script from "./ExpertsCard.js?vue&type=script&lang=js&external"
export * from "./ExpertsCard.js?vue&type=script&lang=js&external"
import style0 from "./ExpertsCard.scss?vue&type=style&index=0&id=7b00af06&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b00af06",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotImage: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Image/Image.vue').default})
